import { useMutation } from "@tanstack/react-query";
import createPrivateAdminPanelInstance from "../api/PrivateAdminPanelInstance";
import { API_ROUTES } from "../api/ApiRoutes";

const approvePendingTransaction = async ({
  transaction_id,
  user_id,
  reason,
}) => {
  if (!transaction_id || !user_id) return;

  const token = JSON.parse(localStorage.getItem("token"));
  const PrivateAdminPanelInstance = createPrivateAdminPanelInstance(
    token?.AccessToken
  );

  const response = await PrivateAdminPanelInstance.post(
    API_ROUTES.APPROVE_PENDING_TRANSACTION,
    {
      transaction_id,
      user_id,
      ...(reason != null && reason !== ""
        ? { reason }
        : {}),
    }
  );

  return response?.data ?? null;
};

export const useApprovePendingTransaction = () => {
  return useMutation({
    mutationKey: ["APPROVE_PENDING_TRANSACTION"],
    mutationFn: approvePendingTransaction,
  });
};
